import React from 'react';
import {observer} from 'mobx-react';
import classNames from 'classnames';
import {ExternalAd} from '../ad/external-ad/external-ad';
import {EXTERNAL_AD_CONFIG} from '../../../apps/website/consts/external-ad-config';
import {AD_DISPLAYS} from '../../consts';
import styles from './sky-scrapper.module.scss';

export const SkyScrapperAd = observer(({controller, className}) => {
  const {device, state} = controller;
  const {isSmallView} = device;
  const {appState} = state;

  if (isSmallView || appState.settings.isWidget) {
    return null;
  }

  const externalAdProps = {
    controller,
    config: EXTERNAL_AD_CONFIG.DESKTOP.SKYSCRAPPER.AD120X600,
    isMock: appState.settings.config.adDisplay === AD_DISPLAYS.placeholders,
    className: classNames(styles.sky_scrapper_ad, className),
  };

  return <ExternalAd {...externalAdProps} />;
});
